import template from './index.pug'
import ListFileForm from './_list-file-form.js'

export default Vue.extend({
  template: template(),
  components: {
    ListFileForm
  },
  data() {
    return {
      data: [],
      meta: {},
      showRobinsonForm: false,
    }
  },
  created() {
    this.$setPageTitle(this.$t('uploadSales.index.title'))
    this.$setBreadcrumbs([
      // eslint-disable-next-line max-len
      {label: this.$t('breadcrumbs.uploadSales.index'), route: {name: 'upload-sales-index'}}
    ])
  },
  computed: {
    canManage() {
      return this.$user.permissions.includes('MANAGE_CALL_CENTERS')
    }
  },
  methods: {
     openNewFileForm() {
      this.showRobinsonForm = true
    },
     closeModalFile() {
      this.showRobinsonForm = false
    },
    loadDdis(queryOptions = {}) {
     
    },
    t(key, options = {}) {
      return this.$t(`analytics.index.${key}`, options)
    },
  }
})
